/**
 * Get the initials of a user name
 * @param name - The name of the user
 * @returns The initials of the user
 */
export const getUserInitials = (name: string): string => {
  return (name || '')
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)
}
